import React from "react";
import PropTypes from "prop-types";
import {
  ResponsiveContainer,
  LabelList,
  BarChart,
  Bar,
  XAxis,
  YAxis
} from "recharts";
import MdBackArrow from "react-icons/lib/md/arrow-back";
import { usePagination, useSort } from "hooks";
import {
  InlineSortControls,
  PageControls,
  AxisLabel
} from "components/ui/graph-components";
import { IconButton } from "components/ui";

const HcpcsBreakdown = ({
  data = [],
  selectedManufacturer,
  selectedHcpcs,
  setSelectedHcpcs
}) => {
  const {
    ascending,
    sortBy,
    getSortedArray,
    toggleSortDirection,
    setSortBy
  } = useSort({ by: "Description", ascending: true });
  const { curPageNum, totalPages, setPageNum, getPageData } = usePagination(
    data,
    8
  );
  return (
    <React.Fragment>
      <div className="interactive-graph-header">
        <IconButton
          style={{ color: "black", marginRight: "10px" }}
          icon={<MdBackArrow />}
          text="Back"
          onClick={() => setSelectedHcpcs()}
        />
        <PageControls
          curPageNum={curPageNum}
          totalPages={totalPages}
          setPageNum={setPageNum}
          alwaysShow={false}
        />
        <h4>
          Manufacturer - {selectedManufacturer.Key} - {selectedHcpcs.Key}
        </h4>
        <InlineSortControls
          sortOptions={[
            { key: "Description", text: "Name" },
            { key: "count", text: "Count" }
          ]}
          setSortBy={setSortBy}
          sortBy={sortBy}
          ascending={ascending}
          toggleSortDirection={toggleSortDirection}
        />
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          layout="vertical"
          data={getPageData(curPageNum, getSortedArray)}
        >
          <XAxis
            type="number"
            dataKey="count"
            domain={[0, "dataMax + 5"]}
            scale="pow"
          />
          <YAxis
            type="category"
            dataKey="Description"
            width={250}
            interval={0}
            tick={
              <AxisLabel
                style={{
                  fontSize: "10px"
                }}
              />
            }
          />
          <Bar dataKey="count" fill="#14c2d0" maxBarSize={30}>
            <LabelList dataKey="count" position="right" />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
};

export default HcpcsBreakdown;

HcpcsBreakdown.propTypes = {
  data: PropTypes.array.isRequired,
  selectedHcpcs: PropTypes.object.isRequired,
  selectedManufacturer: PropTypes.object.isRequired,
  setSelectedHcpcs: PropTypes.func.isRequired
};
